import styled from 'styled-components';
import { ChevronIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';

const ButtonContainerStyled = styled.div`
  display: flex;

  @media screen and (min-width: 768px) {
    width: 50%;
  }
`;
const Title = styled.p`
  width: 100%;
  color: #2d1441;
  font-family: cerapro;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  @media screen and (min-width: 768px) {
    font-size: 24px;
    line-height: 29px;
  }
`;

const FlexLane = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const InvoiceButtonStyled = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr auto;
  box-shadow: 0px 2px 4px rgba(45, 20, 65, 0.15);
  width: 100%;
  align-items: center;
  font-size: 16px;
  line-height: 20px;
  color: #4d008c;
  font-weight: 700;
  border-radius: 8px;
  gap: 8px;
  cursor: pointer;
  padding: 12px 16px;
  transition: all 0.4s;
  background: #ffffff;

  :hover {
    border-color: #4d008c;
  }

  & > div {
    text-align: left;
    border-left: 1px solid #c9cfd7;
    padding-left: 16px;
    height: 100%;
    align-content: center;
  }

  & > svg:first-of-type {
    width: 24px;
    height: 24px;
  }

  @media screen and (min-width: 768px) {
    margin-right: 16px;
  }
`;

const ChevronStyled = styled(ChevronIcon)`
  transform: rotate(-90deg);
`;
export {
  ButtonContainerStyled,
  Title,
  FlexLane,
  InvoiceButtonStyled,
  ChevronStyled,
};
